import { Link } from 'react-router-dom';
import { useState } from 'react';
import { useContacts } from '@/hooks/useContacts';
import { MobileSearchBar } from '@/components/mobile/MobileSearchBar';
import { useDebounce } from '@/hooks/useDebounce';

function getContactName(contact: any) {
  const full = contact.full_name?.trim();
  if (full) return full;
  const first = contact.first_name || '';
  const last = contact.last_name || '';
  const joined = `${first} ${last}`.trim();
  return joined || 'Sem nome';
}

export default function MobileContacts() {
  const [search, setSearch] = useState('');
  const debouncedSearch = useDebounce(search, 300);
  const { contacts, loading, error } = useContacts(false, { searchQuery: debouncedSearch, limit: 100 });

  return (
    <div className="space-y-3 p-3">
      <MobileSearchBar
        value={search}
        onChange={setSearch}
        placeholder="Buscar contato..."
        ariaLabel="Buscar contato"
      />

      {loading ? <p className="text-sm text-muted-foreground">Carregando contatos...</p> : null}
      {error ? <p className="text-sm text-destructive">Erro ao carregar contatos.</p> : null}

      <div className="space-y-2">
        {(contacts || []).map((contact: any) => (
          <Link
            key={contact.id}
            to={`/m/contacts/${contact.id}`}
            className="block rounded-lg border bg-card p-3"
          >
            <p className="text-sm font-semibold">{getContactName(contact)}</p>
            <p className="text-xs text-muted-foreground">{contact.primary_phone || 'Sem telefone'}</p>
          </Link>
        ))}
      </div>

      {!loading && (contacts || []).length === 0 ? (
        <p className="text-sm text-muted-foreground">Nenhum contato encontrado.</p>
      ) : null}
    </div>
  );
}
